<template>
  <div>
    <UserInfo
      ref="userInfo"
      class="mb-4"
      :class="{
        'mt-1': $store.state.requestToBookPath,
        'mt-6': !$store.state.requestToBookPath,
      }"
      :is-form-valid="true"
      @oAuthSubmit="$emit('submit')"
      @click="(element) => track('contact_details', 'click', element)"
    />

    <Captcha :config="$store.state.captcha" @onTokenResponse="(token) => { $store.commit('setCaptchaToken', token); }" />

    <FinishEnquiryButton
      data-test-id="enquiry-form__user-info-btn"
      @click="submit"
    />

    <BackButton
      class="mb-2"
      @click="back"
    />

    <LegalNotice
      class="leading-5"
      :is-account-created-on-this-view="true"
      @terms-and-conditions-click="track('terms_and_conditions')"
      @privacy-policy-click="track('privacy_policy')"
      @cancellation-policy-click="track('cancellation_policy')"
    />
  </div>
</template>

<script>
import BackButton from '../components/buttons/BackButton.vue';
import FinishEnquiryButton from '../components/buttons/FinishEnquiryButton.vue';
import Captcha from '../components/Captcha.vue';
import LegalNotice from '../components/LegalNotice.vue';
import UserInfo from '../forms/UserInfo.vue';

export default {
  name: 'StepUserInfo',
  components: { Captcha, FinishEnquiryButton, LegalNotice, BackButton, UserInfo },

  methods: {
    track(element, interaction = 'click', value = null) {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'signup',
        element,
        interaction,
        value,
      });
    },
    submit() {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'signup',
        element: 'send_message_button',
        value: null,
        interaction: 'click',
      });

      this.$store.dispatch('trackEnquiryFormNavigation', {
        label: 'send-message',
      });
      const { isValid } = this.$refs.userInfo.submit();
      if (isValid) {
        this.$emit('submit');
        this.$store.dispatch('trackEnquiry', 'form');
      }
    },

    back() {
      this.track('back_button');

      this.$store.dispatch('trackEnquiryFormBackNavigation', {
        label: 'back-from-2', // 2nd step in old enquiry form
        errors: this.$refs.userInfo.errors,
        values: this.$refs.userInfo.values,
      });
      this.$emit('back');
    },
  },
};
</script>
